import ScoreTooltip from './ScoreTooltip'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'

const rows = [
  ['528+', '0.61%'],
  ['514-527', '2.05%'],
  ['507-513', '1.84%'],
  ['498-506', '4.50%'],
  ['481-497', '4.92%'],
  ['466-480', '5.46%'],
  ['423-465', '9.58%'],
  ['382-422', '16.64%'],
  ['335-381', '24.33%'],
  ['101-281', '62.49%'],
]

const RiskScoreTooltipContent = () => {
  return (
    <Box>
      <Typography component={'div'} variant={'body2'} sx={{ marginBottom: '10px' }} color={'white'}>
        The Business Credit Risk Score is a risk score provided by Equifax. Equifax assigns businesses a score ranging
        from 101 to 660. The Business Credit Risk Score is generally used in conjunction with the Business Credit Risk
        Class to indicate the likelihood that a business may become severely delinquent on a non-financial account.
        Severely delinquent means 90+ days delinquent on payment, charged off, or bankrupt in the next 12 months. Like a
        consumer credit score, the higher the risk score the lower the risk of severe delinquency.
      </Typography>

      <Typography component={'div'} variant={'body2M'} color={'white'} sx={{ padding: '10px 0', marginBottom: '10px' }}>
        Visit{' '}
        <Link
          href="https://www.equifax.com/"
          underline="hover"
          target="_blank"
          rel="noopener noreferrer"
          sx={{ cursor: 'pointer', textDecorationColor: 'white !important' }}
        >
          <Typography component="span" variant="button2" color="white">
            Equifax.com
          </Typography>
        </Link>
        &nbsp;for more information.
      </Typography>
      <TableContainer component={Paper}>
        <Table aria-label="caption table">
          <TableHead>
            <TableRow>
              <TableCell>Marginal Score Range</TableCell>
              <TableCell>
                Delinquency Rate Within Score Range, %
                <ScoreTooltip content="Proportion of business that are severely delinquent (91 or more days past due, charged-off or bankrupt) on a non-financial account over the next 12 months" />
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(row => (
              <TableRow key={row[0]}>
                <TableCell align="left" size="small" >{row[0]}</TableCell>
                <TableCell align="left" size="small">{row[1]}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Typography component={'div'} variant={'body2'} color={'white'} sx={{ padding: '10px 0', marginTop: '10px' }}>
        A score of zero indicates a bankruptcy on file
      </Typography>
    </Box>
  )
}

export default RiskScoreTooltipContent
